import { useEffect } from "react";

export const EASE = [0.22, 1, 0.36, 1];

export const lineParent = (delay = 0) => ({
  hidden: {},
  show: { transition: { staggerChildren: 0.11, delayChildren: delay } },
});

export const lineChild = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1.15, ease: EASE } },
};

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE } },
};

export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
};
